import { useEffect, useRef } from "react";

function useBrowserHistory(
  name: string | number,
  isActive: boolean,
  onBack: () => void,
  onForward: () => void
) {
  const historyIndex = useRef<number>(
    window.history.state?.[`${name}-index`] ?? 0
  );

  function handlePopState(event: { state: { [key: string]: any } }) {
    const newIndex = event.state?.[`${name}-index`] ?? 0;

    if (newIndex < historyIndex.current) {
      onBack();
    } else if (newIndex > historyIndex.current) {
      onForward();
    }

    historyIndex.current = newIndex;
  }

  useEffect(() => {
    window.addEventListener("popstate", handlePopState);

    if (isActive) {
      window.history.replaceState(
        {
          ...window.history.state,
          [`${name}-index`]: historyIndex.current,
        },
        ""
      );
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isActive, name, onBack, onForward]);

  const navigateForward = () => {
    historyIndex.current += 1;
    window.history.pushState(
      { ...window.history.state, [`${name}-index`]: historyIndex.current },
      ""
    );
    onForward();
  };

  const navigateBackward = () => {
    historyIndex.current -= 1;
    window.history.pushState(
      { ...window.history.state, [`${name}-index`]: historyIndex.current },
      ""
    );
    onBack();
  };

  return { navigateForward, navigateBackward };
}

export default useBrowserHistory;
